<template>
  <div class="Enroll">
    <fp_header></fp_header>
    <div class="spanel" v-if="user.enrolled">
      <enrolled></enrolled>
    </div>
    <div class="panel" v-else>
      <p_area></p_area>
      <p_group></p_group>
      <p_lang></p_lang>
      <!-- <p_coco v-if="user"></p_coco> -->
      <p_invite></p_invite>
      <p_info></p_info>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import FPHeader from '@/components/frontpage/Header.vue'
  import PanelArea from '@/components/enroll/Area.vue'
  import PanelGroup from '@/components/enroll/Group.vue'
  import PanelInvite from '@/components/enroll/Invite.vue'
  import PanelInfo from '@/components/enroll/Info.vue'
  import PanelCoco from '@/components/enroll/Coco.vue'
 import PanelLang from '@/components/enroll/Language.vue'
  import Enrolled from '@/components/enroll/Enrolled.vue'

  export default {
    name: 'Enroll',
    computed: {
      user() {
        return this.$store.state.auth.user
      }
    },
    components: {
      fp_header: FPHeader,
      p_area: PanelArea,
      p_group: PanelGroup,
      p_invite: PanelInvite,
      p_info: PanelInfo,
      p_coco: PanelCoco,
      p_lang: PanelLang,
      enrolled: Enrolled
    },
    mounted() {
      if (!this.user) {
        this.$store.commit('SET_REDIRECT', this.$router.currentRoute.fullPath)
        this.$router.push({
          name: 'account',
          params: {type: 'login'}
        })
      }
    }
  }
</script>

<style scoped>
  .panel{
    height: 104vw;
  }

  .spanel{
    height: 30vw;
  }

  .spanel, .panel{
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
</style>
